import React from 'react';
import styles from './ApplicationRow.module.css';
import { DIRECTORY_TYPES, HTTP_OPTIONS, ROLES } from '@silverfort-nodelibs/common/utils/consts';
import moment from 'moment';
import { httpPost, isUserPermitted } from '../utils';
import { Alert, showAlert } from '@silverfort/sf-components';

const ApplicationRow = ({
    user,
    name,
    directoryName,
    guid,
    authType,
    usersCount,
    authsCount,
    lastUsed,
    supportBridge,
    className
}) => {
    const allowBridge =
        isUserPermitted(user, 'policies', ROLES.EDITOR.value) &&
        isUserPermitted(user, 'applicationsDiscovery', ROLES.EDITOR.value);
    const onOpenPolicyClicked = async () => {
        try {
            const fakeLogRow = {
                protocol_type: 'aad_bridge',
                server_guid: authType !== 'radius' ? guid : undefined,
                server: authType === 'radius' ? guid : undefined,
                directory_type: authType
            };
            if (authType === DIRECTORY_TYPES.adfs.key || authType === DIRECTORY_TYPES.pingfed.key) {
                fakeLogRow.service = 'fake';
            }
            await httpPost(
                '/Logs/openPolicyFromLog',
                {
                    logRow: fakeLogRow
                },
                { [HTTP_OPTIONS.REDIRECT_TO_NEW_TAB]: true }
            );
        } catch (err) {
            console.error('Getting logs failed', err.toString());
            showAlert('Something went wrong, please try again later', 'error');
        }
    };
    const now = moment();
    const lastUsedInDays = now.diff(moment(lastUsed), 'days');
    const lastUsedText = !lastUsed
        ? `N\\A`
        : lastUsedInDays === 0
        ? 'Last 24 hours'
        : lastUsedInDays === 1
        ? '1 Day'
        : `${lastUsedInDays} Days`;

    const appTitle = `${name}${directoryName ? ` (${directoryName})` : ''}`;
    return (
        <>
            <div className={`${className}`}>
                <div className={styles.name} title={appTitle}>
                    {name}
                </div>
                <div>{DIRECTORY_TYPES[authType].displayName}</div>
                <div>{usersCount}</div>
                <div>{authsCount}</div>
                <div>{lastUsedText}</div>
                {supportBridge && (
                    <div
                        className={`${styles.bridge} ${allowBridge ? '' : styles.disabled}`}
                        onClick={onOpenPolicyClicked}>
                        <i className="fa fa-link"></i>
                        <span>Bridge to SSO</span>
                    </div>
                )}
            </div>
            <Alert />
        </>
    );
};

export default ApplicationRow;
